const OHLC_COUNT = 4;

/**
 * Heikin Ashi bar from a bar and the previous Heikin Ashi bar:
 * close = (O + H + L + C) / 4, open = (previous open + previous close) / 2
 * (the first one: (O + C) / 2), high / low also cover the new open and close.
 *
 * @param {{ time: number, open: number, high: number, low: number, close: number }} bar
 * @param {object|undefined} previous - Heikin Ashi bar before it
 * @returns {{ time: number, open: number, high: number, low: number, close: number }}
 */
export const heikinAshiBar = (bar, previous) => {
  const close = (bar.open + bar.high + bar.low + bar.close) / OHLC_COUNT;
  const open = previous ? (previous.open + previous.close) / 2 : (bar.open + bar.close) / 2;

  return {
    time: bar.time,
    open,
    high: Math.max(bar.high, open, close),
    low: Math.min(bar.low, open, close),
    close,
  };
};

/**
 * @param {object[]} bars - oldest first
 * @returns {object[]} Heikin Ashi bars, one per bar
 */
export const buildHeikinAshi = (bars) => {
  const result = [];

  bars.forEach((bar, index) => result.push(heikinAshiBar(bar, result[index - 1])));

  return result;
};
